import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=1733e083&scoped=true"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1733e083",
  null
  
)

export default component.exports